// extracted by mini-css-extract-plugin
var _1 = "CarouselButton-u5olI";
var _2 = "PreviousButtonIcon-d43iB";
export { _1 as "CarouselButton", _2 as "PreviousButtonIcon" }
